import { render, staticRenderFns } from "./JurisdictionIndex.vue?vue&type=template&id=249c867a&"
import script from "./JurisdictionIndex.vue?vue&type=script&lang=js&"
export * from "./JurisdictionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports